import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import "../styles/forgot-password.css";
import globals from '../globals.js';

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setError("");
        setIsLoading(true);

        if (!email) {
            setError("Digite seu e-mail.");
            setIsLoading(false);
            return;
        }

        try {
            const response = await fetch(`${globals.apiBaseUrl}/api/contratoonline/recuperar-senha`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: email })
            });

            const responseData = await response.json();

            if (responseData.status === 'success') {
                // Redireciona para a página de redefinição de senha com o email
                navigate('/redefinir-senha', {
                    state: {
                        email: email,
                        message: responseData.msg || 'Código enviado com sucesso!'
                    }
                });
            } else {
                throw new Error(responseData.msg || 'Não foi possível processar sua solicitação.');
            }
        } catch (error: any) {
            console.error('Erro:', error);
            setError(error.message || 'Ocorreu um erro. Tente novamente.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <React.Fragment>
            {/* Loading Modal */}
            {isLoading && (
                <div className="loading-modal-overlay">
                    <div className="loading-modal">
                        <div className="loading-spinner"></div>
                        <p>Enviando código...</p>
                    </div>
                </div>
            )}

            <Header />
            <form className="main-form-container forgot-password-form" onSubmit={handleSubmit}>
                {error && <div className="main-error-message">{error}</div>}

                <b className="main-header">Recuperar Senha</b>
                <p className="forgot-password-description">
                    Digite seu e-mail cadastrado e enviaremos um código de 6 dígitos para redefinir sua senha.
                </p>

                <div className="form-group">
                    <span>E-MAIL</span>
                    <input
                        type="email"
                        name="email"
                        id="emailEl"
                        placeholder="exemplo@2k20.com.br"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>

                <button type="submit" disabled={isLoading}>
                    {isLoading ? 'Enviando...' : 'Enviar Código'}
                </button>

                <div className="forgot-password-links">
                    <span>Lembrou sua senha? <Link to="/login">Fazer login</Link></span>
                </div>
            </form>
        </React.Fragment>
    );
};

export default ForgotPassword;
